import { plans, shipping, hardware } from '@/data'

const plan = plans.find(plan => plan.map_key === 'standard_yearly')
const headset = hardware.find(hardware => hardware.category === 'headset' && hardware.price > 0)
const batAttachment = hardware.find(hardware => hardware.category === 'bat_attachment' && hardware.price === 0 && hardware.description === 'for Quest 2')
const equipment = [
    headset,
    batAttachment,
]
export default [
    {
        wc_id: import.meta.env.DEV ? 3404 : 118154,
        price: 42900,
        bundle_group_key: 'metaquest2023',
        description: 'Meta Quest 2 Bundle',
        badge: 'Includes Standard Yearly Plan',
        plan: {
            ...plan,
            price: 0,
            hardware_options: equipment,
        },
        equipment,
        shipping_options: shipping.filter(option => option.id === 'standard'),
    },
] as Bundle[]